'use client';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, ModalClose, ModalContent, ModalDescription, ModalHeading } from '@pickleballinc/react-ui';
import { useState } from 'react';

export interface TravelDataProps {
	title: string;
	streetAddr: string;
	city: string;
	state: string;
	zip: number;
	url: string;
	milesFromVenue: number;
	details: string;
}

export const TravelDataCard = (props: TravelDataProps) => {
	const { title, streetAddr, city, state, zip, url, milesFromVenue, details } = props;
	const [detailsModal, setDetailsModal] = useState(false);

	return (
		<>
			<div className="flex flex-col gap-2 text-gray-900">
				<div className="text-lg font-medium">{title}</div>
				<div>
					<div className="font-medium">{streetAddr}</div>
					<div className="font-medium">{`${city}, ${state} ${zip > 0 ? `, ${zip}` : ''}`}</div>
				</div>
				{milesFromVenue > 0 && <div className="text-gray-700">({milesFromVenue} miles from venue)</div>}
				<div className="flex flex-row flex-wrap gap-y-2">
					{details && (
						<Button
							onClick={() => setDetailsModal(true)}
							className="w-1/2 font-normal !text-blue-500 underline sm:w-full xl:w-1/2"
							variant="link"
						>
							View Details
						</Button>
					)}

					{url && (
						<Button className="w-1/2 font-normal !text-blue-500 underline sm:w-full xl:w-1/2" variant="link">
							<a
								target="_blank"
								href={url.includes('http') ? url : `https://${url}`}
								aria-label="Link to travel website (opens in a new tab)"
							>
								Website
							</a>
						</Button>
					)}
				</div>
			</div>

			<Modal onOpenChange={() => setDetailsModal(!detailsModal)} open={detailsModal} backdropClose={false}>
				<ModalContent
					className="flex flex-col justify-center"
					style={{
						width: 800
					}}
				>
					<ModalHeading className="flex w-full items-center justify-between">
						<div className="flex-1 text-xl font-semibold capitalize leading-7 text-gray-900">{title}</div>
						<ModalClose className="ml-auto">
							<FontAwesomeIcon icon={faTimes} size="xl" className="text-gray-500" />
						</ModalClose>
					</ModalHeading>
					<ModalDescription className="mt-4 text-base font-normal text-gray-600">{details}</ModalDescription>
				</ModalContent>
			</Modal>
		</>
	);
};
